import { useCallback, useEffect, useState } from "preact/hooks";
import { isPrimitiveValue } from "@jaybeeuu/recoilless";
import { useAsyncGenerator } from "@jaybeeuu/preact-async";
import { monitorPromise } from "@jaybeeuu/utilities";
import { useStore } from "./store-provider.js";
const useValueStateSubscription = (valueState) => {
    const [, updateState] = useState({});
    const listener = useCallback(() => {
        updateState({});
    }, [valueState]);
    const unsubscribe = valueState.subscribe(listener);
    useEffect(() => () => {
        unsubscribe();
    }, [listener]);
};
const usePrimitiveValue = (value) => {
    const valueState = useStore().getValue(value);
    useValueStateSubscription(valueState);
    return [valueState.current, valueState.set];
};
const useDerivedValue = (value, options) => {
    const valueState = useStore().getValue(value);
    useValueStateSubscription(valueState);
    const current = valueState.current;
    if (current instanceof Promise) {
        return useAsyncGenerator(() => monitorPromise(current, options), { status: "pending" }, [current]);
    }
    return current;
};
export const useValue = (value, options) => {
    return isPrimitiveValue(value)
        ? usePrimitiveValue(value)
        : useDerivedValue(value, options);
};
//# sourceMappingURL=use-value.js.map